import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { fromEvent, map, Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private ENDPOINT: string = environment.api.url;
  private VERSION: string = environment.api.version;

  httpClient = inject(HttpClient);

  get(basePath: string, subPath: string): Observable<any> {
    return this.httpClient.get(
      `${this.ENDPOINT}/api/v${this.VERSION}/${basePath}/${subPath}`
    );
  }

  post(basePath: string, subPath: string, data: any): Observable<any> {
    return this.httpClient.post(
      `${this.ENDPOINT}/api/v${this.VERSION}/${basePath}/${subPath}`,
      data
    );
  }

  put(basePath: string, subPath: string, data: any): Observable<any> {
    return this.httpClient.put(
      `${this.ENDPOINT}/api/v${this.VERSION}/${basePath}/${subPath}`,
      data
    );
  }

  patch(basePath: string, subPath: string, data: any): Observable<any> {
    return this.httpClient.patch(
      `${this.ENDPOINT}/api/v${this.VERSION}/${basePath}/${subPath}`,
      data
    );
  }

  delete(basePath: string, subPath: string, data?: any): Observable<any> {
    return data
      ? this.httpClient.request(
        'delete',
        `${this.ENDPOINT}/api/v${this.VERSION}/${basePath}/${subPath}`,
        { body: data }
      )
      : this.httpClient.delete(
        `${this.ENDPOINT}/api/v${this.VERSION}/${basePath}/${subPath}`
      );
  }

  getClob(
    basePath: string,
    id: any,
    download: boolean = true,
    name: string
  ): Observable<any> {
    return this.httpClient
      .get(`${basePath}/${id}`, {
        responseType: 'blob',
      })
      .pipe(
        map((response: any) => {
          const dataType = response.type;
          const binaryData = [];
          binaryData.push(response);
          const downloadLink = document.createElement('a');
          var objectUrl = window.URL.createObjectURL(
            new Blob(binaryData, { type: dataType })
          );
          downloadLink.href = objectUrl;
          if (download) {
            downloadLink.download = name;
          } else {
            downloadLink.target = '_blank';
          }
          downloadLink.click();
          URL.revokeObjectURL(objectUrl);
        })
      );
  }

  getClobPreview(basePath: string, id: string): Observable<any> {
    return this.httpClient
      .get(`${basePath}/${id}`, { responseType: 'blob' })
      .pipe(
        switchMap((response: Blob) => {
          const reader = new FileReader();
          reader.readAsDataURL(response);

          return fromEvent(reader, 'load').pipe(
            map(() => reader.result as string)
          );
        })
      );
  }

  postAbsolute(path: string, data: any): Observable<any> {
    return this.httpClient.post(path, data);
  }

  getAbsolute(path: string): Observable<any> {
    return this.httpClient.get(path);
  }

}
